'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_OpaqueType$package$$anon$4(evaluator$4) {
  this.Lp = null;
  this.Lp = evaluator$4;
}
export { $c_Lsamples_OpaqueType$package$$anon$4 as $c_Lsamples_OpaqueType$package$$anon$4 };
$p = $c_Lsamples_OpaqueType$package$$anon$4.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_OpaqueType$package$$anon$4;
/** @constructor */
function $h_Lsamples_OpaqueType$package$$anon$4() {
}
export { $h_Lsamples_OpaqueType$package$$anon$4 as $h_Lsamples_OpaqueType$package$$anon$4 };
$h_Lsamples_OpaqueType$package$$anon$4.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lp.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_OpaqueType$package$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_OpaqueType$package$$anon$4, "samples.OpaqueType$package$$anon$4", ({
  pt: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_OpaqueType$package$$anon$4 as $d_Lsamples_OpaqueType$package$$anon$4 };
